import React, { Fragment } from 'react'
import {Link} from 'react-router-dom'


const ThemeMainMenu = () => {
  return (
    <Fragment>
      <ul className="navbar-nav d-flex flex-row align-items-center">
            <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/about">About Us</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/services">Services</Link>
            </li>
            {/* <li className="nav-item">
                <Link className="nav-link" to="/projects">Projects</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/blog">Blog</Link>
            </li> */}
            
            <li className="nav-item">
             <Link className="nav-link custom-badge-parent" to="/cruxestacksign">
               Cruxestack Sign
               {/* <span className="coming-soon-mini">Coming Soon</span> */}
             </Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/contact">Contact</Link>
            </li>
        </ul>
      
    </Fragment>
  )
}

export default ThemeMainMenu